import { render } from "./VisualTab.vue?vue&type=template&id=7ff26789&scoped=true"
import script from "./VisualTab.vue?vue&type=script&lang=js"
export * from "./VisualTab.vue?vue&type=script&lang=js"

import "./VisualTab.vue?vue&type=style&index=0&id=7ff26789&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff26789"]])

export default __exports__